import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=42ce8506&scoped=true"
import script from "./UpdateButton.vue?vue&type=script&lang=js"
export * from "./UpdateButton.vue?vue&type=script&lang=js"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=42ce8506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce8506",
  null
  
)

export default component.exports